import getUsedLocale from '../../utils/get-used-locale'
import { Component } from 'vue'
import { Header } from '@/types/Header.type'

export type State = {
    configuration: any | null
    headerConfiguration: Header | null
    usedLocale: string | null
    curentPath: string | null
    selectedDeviceId: {
        audio: string
        video: boolean | string | null
    }
    layoutComponent: null | Component
    layoutProps: null | any
    maintenance: false
}

const state: State = {
    configuration: null,
    headerConfiguration: null,
    usedLocale: getUsedLocale(),
    curentPath: null,
    selectedDeviceId: {
        audio: 'default',
        video: true,
    },
    layoutComponent: null,
    layoutProps: null,
    maintenance: false,
}

export default state
